var auth = require('./auth');

require('./plugins/register-form');
require('./plugins/login-form');

var ycgame = window.ycgame || {};
ycgame.auth = auth;
window.ycgame = ycgame;

module.exports = ycgame;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth/src/index.js
// module id = 7
// module chunks = 1